import { useState, useCallback } from "react";
import { getInstanceSessionDefault } from "../common/App.service";
import { ISessionConfig } from "../common/App.interface";
import { logger } from "../services/logger.service";

const SESSION_DEFAULT_INITIAL_STATE: ISessionConfig = {
  isInactivityActive: false,
  inactivityLength: 0,
  inactivityTimeout: 0,
  isSessionExpiryActive: false,
  sessionLength: 0,
  sessionTimeout: 0,
};

export const useSessionConfig = () => {
  const [sessionDefault, setSessionDefault] = useState<ISessionConfig>(
    SESSION_DEFAULT_INITIAL_STATE,
  );
  const [isSessionDefaultLoaded, setIsSessionDefaultLoaded] = useState(false);

  const fetchSessionConfig = useCallback((): Promise<void> => {
    return getInstanceSessionDefault()
      .then((data: ISessionConfig) => {
        setSessionDefault(data);
        setIsSessionDefaultLoaded(true);
      })
      .catch((error) => {
        logger.error("Failed to get session defaults", error, {
          component: "useSessionConfig",
          action: "fetchSessionConfig",
        });
        throw error;
      });
  }, []);

  return {
    sessionDefault,
    setSessionDefault,
    isSessionDefaultLoaded,
    fetchSessionConfig,
  };
};
